import EfIcon from '@elem/ui/ef-icon';
import EfImgListA from '@elem/ui/ef-img-list-a';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTabHoverA from '@elem/ui/ef-tab-hover-a';
import { useState } from 'react';
import { useProductStore } from '../../../ProductProvider';
import { IPageStatus } from '../../../config/IPageStatus';
import { PRODUCT_R3, PRODUCT_R3P } from '../../index';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { pageStatus } = useProductStore();
    const { t } = useLang('theProduct.SectionC');
    const { t: t2 } = useLang('theProduct');
    const itemsA1 = [
        {
            title: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723542426317/r3_01.jpg',
        },
        {
            title: t('item_a1_title'),
            desc: t('item_a1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723010335154/r3_02.jpg',
        },
        {
            title: t('item_a2_title'),
            desc: t('item_a2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723010334890/r3_03.jpg',
        },
        {
            title: t('item_a3_title'),
            desc: t('item_a3_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723010335614/r3_04.jpg',
        },
        {
            title: t('item_a4_title'),
            desc: t('item_a4_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723010334708/r3_05.jpg',
        },
    ];
    const itemsA2 = [
        {
            title: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723542426136/r3p_01.jpg',
        },
        {
            title: t('item_b1_title'),
            desc: t('item_b1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723010620956/r3p_02.jpg',
        },
        {
            title: t('item_b2_title'),
            desc: t('item_b2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723010621412/r3p_03.jpg',
        },
        {
            title: t('item_b3_title'),
            desc: t('item_b3_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723010621611/r3p_04.jpg',
        },
        {
            title: t('item_b4_title'),
            desc: t('item_b4_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724206669445/r3p_05.jpg',
        },
    ];
    const itemsB1 = [
        {
            key: 'a1',
            tabName: t('box1_tab'),
            pc: PRODUCT_R3,
            label: pageStatus === IPageStatus.statusC ? '' : t('box1_label'),
            title: t('box1_title'),
            descList: [t('box1_desc1'), t('box1_desc2'), t('box1_desc3')],
            moreIcon: <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1721387712963/a1.png" />,
            moreLink: '#section-SectionG',
            moreText: pageStatus === IPageStatus.statusC ? t('box1_btn1_2') : t('box1_btn1'),
            moreDataLayer: [
                {
                    event: 'uaEvent',
                    event_name: 'click_anchor',
                    position: pageStatus === IPageStatus.statusC ? `${t('box1_title')}_${t2('SectionG.title2')}` : `${t('box1_title')}_${t2('SectionG.title')}`,
                    button_name: pageStatus === IPageStatus.statusC ? t('box1_btn1_2') : t('box1_btn1'),
                },
            ],
            buyIcon: <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1721387747560/a2.png" />,
            buyLink: 'https://www.amazon.co.jp/dp/B0DB5Y5JZR',
            buyText: pageStatus === IPageStatus.statusC ? t('box1_btn2_2') : t('box1_btn2'),
            buyDataLayer: [
                {
                    event: 'uaEvent',
                    event_name: 'buy_on_amazon',
                    product_name: t('box1_title'),
                    button_name: pageStatus === IPageStatus.statusC ? t('box1_btn2_2') : t('box1_btn2'),
                    list_name: t('box1_title'),
                },
            ],
            buyBtnDisabled: pageStatus !== IPageStatus.statusC,
        },
        {
            key: 'a2',
            tabName: t('box2_tab'),
            pc: PRODUCT_R3P,
            label: t('box2_label'),
            title: t('box2_title'),
            descList: [t('box2_desc1'), t('box2_desc2'), t('box2_desc3')],
        },
    ];
    const [itemsA, setItemsA] = useState(itemsA1);
    const [itemsB, setItemsB] = useState(itemsB1);
    const [product, setProduct] = useState('R3');

    // 回调
    const callbackHandle = (item: any) => {
        if (item.key === 'a1') {
            setItemsA(itemsA1);
            setProduct('R3');
        } else if (item.key === 'a2') {
            setItemsA(itemsA2);
            setProduct('R3P');
        }
    };

    return (
        <div className={styles.TheComp} id="section-SectionC">
            <EfSpec />
            <EfSection title={t('title')} desc={t('desc')} />
            <EfImgListA items={itemsA} className={product} />
            <EfTabHoverA items={itemsB} callback={callbackHandle} />
        </div>
    );
}
